import {FilemanagerApi} from '@requests/index';
import {isEmpty} from 'lodash';

export const saveFilesRequest = async (acceptedFiles, organizationId, apiDomainFilemanager) => {
    const filemanagerApi = new FilemanagerApi(apiDomainFilemanager);
    const chainPromises = acceptedFiles.map((file) => {
        return new Promise((resolve) => {
            filemanagerApi.uploadFile(file, organizationId)
                .then((result) => {
                    resolve({file, result});
                });
        });
    });
    return await Promise.all(chainPromises);
};

export const deleteFileRequest = async (fileId, apiDomainFilemanager) => {
    const filemanagerApi = new FilemanagerApi(apiDomainFilemanager);
    return await filemanagerApi.deleteFile(fileId);
};

export const deleteFilesRequest = async (fileIds, apiDomainFilemanager) => {
    const filemanagerApi = new FilemanagerApi(apiDomainFilemanager);
    return await filemanagerApi.deleteFiles(fileIds);
};

export const changeFilesNotTemporaryStatus = async (fileIds, apiDomainFilemanager) => {
    const filemanagerApi = new FilemanagerApi(apiDomainFilemanager);
    return await filemanagerApi.changeFilesNotTemporaryStatus(fileIds);
};

export const collectFileIdsFromDocuments = (documents) => {
    let result = [];
    Object.keys(documents).forEach((index) => {
        const {file_ids: fileIds} = documents[index];
        if (fileIds && !isEmpty(fileIds)) {
            result = result.concat(fileIds);
        }
    });
    return result;
};

export const preProcessingFilesSave = (data) => {
    let idsForDelete = [];
    let idsForSave = [];
    let afterSuccessSaveCallback = null;
    if (data.hasOwnProperty('file_ids')) {
        const fileIds = data.file_ids.values();
        afterSuccessSaveCallback = data.file_ids.successSaved;
        idsForDelete = fileIds.ids_for_delete;
        data.file_ids = idsForSave = fileIds.ids_for_send;
    }
    return [idsForSave, idsForDelete, afterSuccessSaveCallback];
};

/* После успешного сохранения необходимо
1. Удалить файлы, которые уже были зафиксированы в системе vikon и которые пользователь предпочел удалить
2. Убрать статус временного файла у всех файлов, сохраненных в vikon
3. Вызвать callback функцию, которая меняет локальный state в компоненте загрузки файлов,
чтобы очистить идентификаторы файлов для удаления, убрать у всех файлов статус временных
 */
export const postProcessingFileSave = async (idsForSave, idsForDelete, afterSuccessSaveCallback, apiDomainFilemanager) => {
    if (!isEmpty(idsForDelete)) {
        await deleteFilesRequest(idsForDelete, apiDomainFilemanager);
    }
    if (!isEmpty(idsForSave)) {
        await changeFilesNotTemporaryStatus(idsForSave, apiDomainFilemanager);
    }
    if (afterSuccessSaveCallback && typeof afterSuccessSaveCallback === 'function') {
        afterSuccessSaveCallback();
    }
};

export const mapApiFile = (file) => {
    return {
        id: Number(file.id),
        name: [file.title, file.file_ext].join('.'),
        size: file.size,
        link: file.link,
    };
};

export const combineUploadFileInfoWithApiFile = (apiFile, uploadFile) => {
    return {
        id: Number(apiFile.id),
        size: uploadFile.size,
        name: uploadFile.name,
        link: apiFile.link,
    };
};

export const getFilesInfoFromSprByFileIds = (fileIds, filesSpr) => {
    return !isEmpty(fileIds) && filesSpr
        ? fileIds
            .map((fileId) => {
                const file = filesSpr.find(({id}) => { return Number(id) === Number(fileId); });
                if (file) {
                    return {
                        ...mapApiFile(file),
                        confirmed: true,
                    };
                }
            })
            .filter((file) => { return file; })
        : [];
};
